import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class DyNewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.news_list} onMouseEnter={this.handleOver} onMouseLeave={this.handleOver}>
                <div className={styles.box}>
                    <div className={styles.list}>
                        <ul>
                            {content.map((item, index) => (
                                <li key={index}>
                                    <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                        {item.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(DyNewsList);
